import React from 'react';
import {CheckIcon, EyeOpen, InactiveIcon, PendingIcon} from "../assets/icons/Icons";
import '../assets/scss/components/chip.scss'
import CustomTooltip from "./CustomTooltip";

const Chip = (props) => {
    const renderIcon = () => {
        switch (props.state) {
            case 'active':
                return <CheckIcon />;
            case 'inactive':
                return <InactiveIcon />;
            case 'pending':
                return <PendingIcon />;
            default:
                return null;
        }
    };
    return (
        <span className={`chip ${props.state} ${props.showAsTooltop ? 'show-as-tooltop' : ''}`}>
            {props.showAsTooltop ? (
                <CustomTooltip icon={renderIcon()} message={props.label} />
            ) : (
                <>
                    {renderIcon()}
                    {props.label}
                </>
            )}
        </span>
    );
};

export default Chip;
